import React from 'react';
import Svg, { Mask, Path, Rect, Circle, ClipPath, G, Defs } from 'react-native-svg';

export function CropIcon({ width, height }) {
  return (
    <>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath="url(#clip0_2147_7019)">
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.0928 17C2.01466 17 1.94629 16.9303 1.94629 16.8407V8.40539C1.94629 8.31576 2.01466 8.24604 2.0928 8.24604C2.18071 8.24604 2.24908 8.31576 2.24908 8.40539V16.8407C2.24908 16.9303 2.18071 17 2.0928 17Z"
            fill="#8BC34A"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.09337 8.55477C2.05406 8.55477 2.01475 8.53486 1.98526 8.50498C1.59213 8.10662 1.38574 7.57879 1.38574 7.01113C1.38574 6.45343 1.59213 5.91564 1.98526 5.51728C2.04423 5.45753 2.14251 5.45753 2.20148 5.51728C2.59461 5.91564 2.81083 6.45343 2.81083 7.01113C2.81083 7.57879 2.59461 8.10662 2.20148 8.50498C2.172 8.53486 2.13268 8.55477 2.09337 8.55477Z"
            fill="#689F38"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.09371 10.3773C2.0544 10.3773 2.01509 10.3574 1.9856 10.3374C1.95612 10.3076 1.94629 10.2677 1.94629 10.2279C1.94629 9.66022 2.16251 9.1324 2.55564 8.73404C2.94876 8.33568 3.46966 8.11658 4.02986 8.10662C4.06918 8.10662 4.10849 8.12654 4.13797 8.15642C4.16746 8.18629 4.17729 8.22613 4.17729 8.26596C4.17729 8.82367 3.96107 9.36145 3.56794 9.75981C3.17481 10.1582 2.65392 10.3773 2.09371 10.3773Z"
            fill="#689F38"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.09334 10.3773C1.54296 10.3773 1.01224 10.1582 0.619113 9.75981C0.225986 9.36145 0.00976562 8.82367 0.00976562 8.26596C0.00976562 8.22613 0.0195938 8.18629 0.0490783 8.15642C0.0785629 8.12654 0.117876 8.10662 0.157188 8.10662C0.717394 8.11658 1.23829 8.33568 1.63141 8.73404C2.01471 9.12244 2.24076 9.65026 2.25059 10.198V10.2279C2.25059 10.3076 2.18179 10.3773 2.09334 10.3773Z"
            fill="#689F38"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.09371 12.4189C2.0544 12.4189 2.01509 12.3989 1.9856 12.3691C1.95612 12.3392 1.94629 12.2994 1.94629 12.2595C1.94629 11.7018 2.16251 11.174 2.55564 10.7756C2.94876 10.3773 3.46966 10.1482 4.02986 10.1482C4.06918 10.1482 4.10849 10.1681 4.13797 10.198C4.16746 10.2279 4.17729 10.2677 4.17729 10.3076C4.17729 10.8653 3.96107 11.3931 3.56794 11.7914C3.17481 12.1898 2.65392 12.4189 2.09371 12.4189Z"
            fill="#689F38"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.09334 12.4189C1.54296 12.4189 1.01224 12.1898 0.619113 11.7914C0.225986 11.3931 0.00976562 10.8653 0.00976562 10.3076C0.00976562 10.2677 0.0195938 10.2279 0.0490783 10.198C0.0785629 10.1681 0.117876 10.1482 0.157188 10.1482C0.717394 10.1482 1.23829 10.3773 1.63141 10.7756C2.01471 11.164 2.24076 11.6819 2.25059 12.2396V12.2595C2.25059 12.3491 2.18179 12.4189 2.09334 12.4189Z"
            fill="#689F38"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.09371 14.4605C2.0544 14.4605 2.01509 14.4405 1.9856 14.4107C1.95612 14.3808 1.94629 14.3409 1.94629 14.3011C1.94629 13.7434 2.16251 13.2056 2.55564 12.8073C2.94876 12.4089 3.46966 12.1898 4.02986 12.1898C4.06918 12.1898 4.10849 12.2097 4.13797 12.2296C4.16746 12.2595 4.17729 12.2994 4.17729 12.3392C4.17729 12.9069 3.96107 13.4347 3.56794 13.833C3.17481 14.2314 2.65392 14.4505 2.09371 14.4605Z"
            fill="#689F38"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.09334 14.4605C1.54296 14.4505 1.01224 14.2314 0.619113 13.833C0.225986 13.4347 0.00976562 12.9069 0.00976562 12.3392C0.00976562 12.2994 0.0195938 12.2595 0.0490783 12.2296C0.0785629 12.2097 0.117876 12.1898 0.157188 12.1898C0.717394 12.1898 1.23829 12.4089 1.63141 12.8073C2.01471 13.2056 2.24076 13.7235 2.25059 14.2812V14.3011C2.25059 14.3907 2.18179 14.4605 2.09334 14.4605Z"
            fill="#689F38"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.4278 17C14.3295 17 14.2607 16.9203 14.2607 16.8207V7.36965C14.2607 7.27006 14.3295 7.20035 14.4278 7.20035C14.5261 7.20035 14.5949 7.27006 14.5949 7.36965V16.8207C14.5949 16.9203 14.5261 17 14.4278 17Z"
            fill="#8BC34A"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.4279 7.53896C14.3788 7.53896 14.3395 7.51904 14.31 7.48916C13.8677 7.04101 13.6318 6.44347 13.6318 5.81605C13.6318 5.17868 13.8677 4.5911 14.31 4.14294C14.3689 4.07323 14.4869 4.07323 14.5459 4.14294C14.9881 4.5911 15.224 5.17868 15.224 5.81605C15.224 6.44347 14.9881 7.04101 14.5459 7.48916C14.5164 7.51904 14.4771 7.53896 14.4279 7.53896Z"
            fill="#689F38"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.4278 9.58055C14.3787 9.58055 14.3394 9.56063 14.3099 9.53076C14.2804 9.50088 14.2607 9.46104 14.2607 9.41125C14.2607 8.78383 14.5064 8.18629 14.9487 7.73814C15.391 7.28998 15.9708 7.05097 16.59 7.04101C16.6392 7.04101 16.6785 7.06093 16.7178 7.0908C16.7473 7.13064 16.7669 7.17047 16.7669 7.22027C16.7571 7.84769 16.5212 8.43527 16.079 8.88342C15.6367 9.33158 15.047 9.58055 14.4278 9.58055Z"
            fill="#689F38"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.428 9.58055C13.8088 9.58055 13.2191 9.33158 12.7768 8.88342C12.3346 8.43527 12.0987 7.84769 12.0889 7.22027C12.0889 7.17047 12.1085 7.13064 12.138 7.0908C12.1675 7.06093 12.2166 7.04101 12.2559 7.04101H12.2658C12.8849 7.05097 13.4648 7.28998 13.9071 7.73814C14.3395 8.17633 14.5852 8.76391 14.5951 9.38137V9.41125C14.5951 9.51084 14.5263 9.58055 14.428 9.58055Z"
            fill="#689F38"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.4278 11.8711C14.3787 11.8711 14.3394 11.8512 14.3099 11.8213C14.2804 11.7815 14.2607 11.7417 14.2607 11.6919C14.2607 11.0644 14.5064 10.4669 14.9487 10.0287C15.391 9.58055 15.9708 9.33158 16.59 9.33158C16.6392 9.32162 16.6785 9.34154 16.7178 9.38137C16.7473 9.41125 16.7669 9.45109 16.7669 9.50088C16.7571 10.1283 16.5212 10.7258 16.079 11.174C15.6367 11.6122 15.047 11.8612 14.4278 11.8711Z"
            fill="#689F38"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.428 11.8711C13.8088 11.8612 13.2191 11.6122 12.7768 11.174C12.3346 10.7258 12.0987 10.1283 12.0889 9.50088C12.0889 9.45109 12.1085 9.41125 12.138 9.38137C12.1675 9.34154 12.2166 9.33158 12.2658 9.33158C12.8849 9.33158 13.4648 9.58055 13.9071 10.0287C14.3395 10.4669 14.5852 11.0445 14.5951 11.662V11.6919C14.5951 11.7914 14.5263 11.8711 14.428 11.8711Z"
            fill="#689F38"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.4278 14.1517C14.3787 14.1517 14.3394 14.1318 14.3099 14.1019C14.2804 14.0721 14.2607 14.0223 14.2607 13.9824C14.2607 13.3451 14.5064 12.7575 14.9487 12.3093C15.391 11.8612 15.9708 11.6122 16.59 11.6122C16.6392 11.6122 16.6785 11.6321 16.7178 11.662C16.7473 11.6919 16.7669 11.7417 16.7669 11.7815C16.7571 12.4189 16.5212 13.0064 16.079 13.4546C15.6367 13.9028 15.047 14.1517 14.4278 14.1517Z"
            fill="#689F38"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.428 14.1517C13.8088 14.1517 13.2191 13.9028 12.7768 13.4546C12.3346 13.0064 12.0987 12.4189 12.0889 11.7815C12.0889 11.7417 12.1085 11.6919 12.138 11.662C12.1675 11.6321 12.2166 11.6122 12.2658 11.6122C12.8849 11.6122 13.4648 11.8612 13.9071 12.3093C14.3395 12.7475 14.5852 13.3351 14.5951 13.9525V13.9824C14.5951 14.0721 14.5263 14.1517 14.428 14.1517Z"
            fill="#689F38"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.30466 17C8.1769 17 8.07861 16.8905 8.07861 16.7709V4.31225C8.07861 4.19274 8.1769 4.09315 8.30466 4.09315C8.43243 4.09315 8.53071 4.19274 8.53071 4.31225V16.7709C8.53071 16.8905 8.43243 17 8.30466 17Z"
            fill="#8BC34A"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.30454 4.5413C8.24558 4.5413 8.18661 4.52138 8.14729 4.47159C7.56743 3.88401 7.25293 3.09725 7.25293 2.27065C7.25293 1.44405 7.56743 0.657293 8.14729 0.0697123C8.22592 -0.0199186 8.38317 -0.0199186 8.4618 0.0697123C9.04166 0.657293 9.35616 1.44405 9.35616 2.27065C9.35616 3.09725 9.04166 3.88401 8.4618 4.47159C8.42248 4.52138 8.36351 4.5413 8.30454 4.5413Z"
            fill="#689F38"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.30466 7.23023C8.24569 7.23023 8.18672 7.21031 8.14741 7.17047C8.1081 7.12068 8.07861 7.07088 8.07861 7.01113C8.08844 6.17457 8.41277 5.39777 8.99263 4.81019C9.5725 4.22261 10.3391 3.89397 11.1548 3.88401C11.2236 3.88401 11.2728 3.91388 11.3219 3.95372C11.3612 3.99356 11.3809 4.05331 11.3809 4.11306C11.3809 4.94962 11.0566 5.72642 10.4767 6.314C9.89683 6.90158 9.13023 7.23023 8.30466 7.23023Z"
            fill="#689F38"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.30474 7.23023C7.47917 7.23023 6.71257 6.90158 6.13271 6.314C5.55285 5.72642 5.22852 4.94962 5.22852 4.11306C5.22852 4.05331 5.24817 3.99356 5.29731 3.95372C5.33663 3.91388 5.39559 3.88401 5.45456 3.88401C6.2703 3.89397 7.04673 4.22261 7.62659 4.81019C8.19663 5.38781 8.51113 6.15466 8.53078 6.97129V7.01113C8.53078 7.13064 8.4325 7.23023 8.30474 7.23023Z"
            fill="#689F38"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.30466 10.2378C8.24569 10.2378 8.18672 10.2179 8.14741 10.1781C8.1081 10.1283 8.07861 10.0785 8.07861 10.0187C8.08844 9.18219 8.41277 8.40539 8.99263 7.81781C9.5725 7.23023 10.3391 6.90158 11.1548 6.90158C11.2236 6.89162 11.2728 6.9215 11.3219 6.96133C11.3612 7.00117 11.3809 7.06092 11.3809 7.12068C11.3809 7.95723 11.0566 8.73404 10.4767 9.32162C9.89683 9.9092 9.13023 10.2378 8.30466 10.2378Z"
            fill="#689F38"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.30474 10.2378C7.47917 10.2378 6.71257 9.9092 6.13271 9.32162C5.55285 8.73404 5.22852 7.95723 5.22852 7.12068C5.22852 7.06092 5.24817 7.00117 5.29731 6.96133C5.33663 6.9215 5.39559 6.89162 5.45456 6.90158C6.2703 6.90158 7.04673 7.23023 7.62659 7.81781C8.19663 8.39543 8.51113 9.16227 8.53078 9.97891V10.0187C8.53078 10.1383 8.4325 10.2378 8.30474 10.2378Z"
            fill="#689F38"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.30466 13.2455C8.24569 13.2455 8.18672 13.2255 8.14741 13.1857C8.1081 13.1359 8.07861 13.0861 8.07861 13.0264C8.08844 12.1898 8.41277 11.413 8.99263 10.8254C9.5725 10.2378 10.3391 9.90919 11.1548 9.90919C11.2236 9.89924 11.2728 9.92911 11.3219 9.96895C11.3612 10.0088 11.3809 10.0685 11.3809 10.1283C11.3809 10.9648 11.0566 11.7416 10.4767 12.3292C9.89683 12.9168 9.13023 13.2455 8.30466 13.2455Z"
            fill="#689F38"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.30474 13.2455C7.47917 13.2455 6.71257 12.9168 6.13271 12.3292C5.55285 11.7416 5.22852 10.9648 5.22852 10.1283C5.22852 10.0685 5.24817 10.0088 5.29731 9.96895C5.33663 9.92911 5.39559 9.89924 5.45456 9.90919C6.2703 9.90919 7.04673 10.2378 7.62659 10.8254C8.19663 11.403 8.51113 12.1699 8.53078 12.9865V13.0264C8.53078 13.1459 8.4325 13.2455 8.30474 13.2455Z"
            fill="#689F38"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.6762 17H1.09122C0.973282 17 0.875 16.8905 0.875 16.7709C0.875 16.6415 0.973282 16.5419 1.09122 16.5419H15.6762C15.804 16.5419 15.9023 16.6415 15.9023 16.7709C15.9023 16.8905 15.804 17 15.6762 17Z"
            fill="#E2926F"
          />
        </G>
        <Defs>
          <ClipPath id="clip0_2147_7019">
            <Rect width="16.7767" height="17" rx="8.38835" fill="white" />
          </ClipPath>
        </Defs>
      </Svg>
    </>
  );
}
